export default __webpack_public_path__ + "static/media/bonus1.617a48ef.mov";